var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import DataPresenter from '../../data-presenter';
import PrimarySubmenu from './primary-submenu';
import SecondarySubmenu from '../secondary-submenu';
import { Logo, LeftSide, RightSide, WidgetIcon, WidgetItem, WidgetWrapper, Link } from '../Header.styles';
import { NavigationItem, NavigationLinks, NavLink, DesktopWrapper, WidgetItemLabel } from './HeaderDesktop.styles';
import { mergeTwoRefs } from './utils';
import LanguageSwitcher from '../language-switcher';
import { black } from '../../colors';

var HeaderDesktop = function HeaderDesktop(_a) {
  var isLoading = _a.isLoading,
      content = _a.content,
      _b = _a.locale,
      locale = _b === void 0 ? 'en' : _b,
      _c = _a.linkComponent,
      linkComponent = _c === void 0 ? 'a' : _c,
      _d = _a.widgetActions,
      widgetActions = _d === void 0 ? {} : _d,
      _e = _a.translationLinks,
      translationLinks = _e === void 0 ? [] : _e,
      _f = _a.t,
      t = _f === void 0 ? function (key) {
    return key;
  } : _f,
      state = __rest(_a, ["isLoading", "content", "locale", "linkComponent", "widgetActions", "translationLinks", "t"]);

  var currentSubmenuId = state.headerSubmenu;
  var linkRefs = React.useRef([]);
  var secondaryRefs = React.useRef([]);

  var widgetActivate = function widgetActivate(navLinkId) {
    /* Close popup since it won't close for this element */
    if (currentSubmenuId === navLinkId) {
      state.setHeaderSubmenu(null);
      return;
    }

    state.setHeaderSubmenu(navLinkId);
  };

  var secWidgetActivate = function secWidgetActivate(secLinkId) {
    /* Close popup since it won't close for this element */
    if (currentSubmenuId === "sec-" + secLinkId) {
      state.setHeaderSubmenu(null);
      return;
    }

    state.setHeaderSubmenu("sec-" + secLinkId);
  };

  var secWidgetNoBubItemsActivate = function secWidgetNoBubItemsActivate(secLinkHandlerId) {
    if (!widgetActions[secLinkHandlerId]) {
      throw new Error('Widget handler id doesnt match any widget');
    }

    widgetActions[secLinkHandlerId](locale);
  };

  return /*#__PURE__*/React.createElement(DesktopWrapper, {
    "data-test": 'header-desktop'
  }, /*#__PURE__*/React.createElement(LeftSide, null, isLoading || !content ? /*#__PURE__*/React.createElement(DataPresenter, {
    nodata: true,
    loading: isLoading || false,
    width: 8,
    height: 4
  }) : /*#__PURE__*/React.createElement(Link, {
    as: linkComponent,
    href: (content === null || content === void 0 ? void 0 : content.homeUrl) || '/',
    onClick: function onClick() {
      return !isLoading && state.setMenuOpen(false);
    }
  }, /*#__PURE__*/React.createElement(Logo, {
    src: content.logo.url,
    alt: content.logo.alternativeText || '',
    "data-test": 'header-desktop-logo',
    "data-gtm": 'header-logo-desktop',
    loading: 'lazy'
  })), /*#__PURE__*/React.createElement(NavigationLinks, {
    "data-test": 'rtl'
  }, isLoading || !content ? [1, 2, 3, 4].map(function (i) {
    return /*#__PURE__*/React.createElement(NavigationItem, {
      key: i,
      "data-test": 'header-desktop-navigation-link'
    }, /*#__PURE__*/React.createElement(DataPresenter, {
      nodata: true,
      loading: isLoading || false,
      width: 6,
      height: 2
    }));
  }) : content.navigationLinks.map(function (navLink, i) {
    return /*#__PURE__*/React.createElement(NavigationItem, {
      key: navLink.id,
      "data-test": 'header-desktop-navigation-link'
    }, navLink.submenuRows && navLink.submenuRows.length ? /*#__PURE__*/React.createElement(WidgetItem, {
      "data-test": 'header-desktop-submenu-link',
      ref: function ref(el) {
        if (linkRefs === null || linkRefs === void 0 ? void 0 : linkRefs.current) {
          linkRefs.current[i] = {
            current: el
          };
        }
      },
      tabIndex: 0,
      onClick: function onClick() {
        return widgetActivate(navLink.id);
      },
      onKeyPress: function onKeyPress(e) {
        if (e.key === 'Enter') {
          widgetActivate(navLink.id);
        }
      }
    }, navLink.label) : /*#__PURE__*/React.createElement(NavLink, {
      href: navLink.link || '#',
      as: linkComponent,
      activeStyle: {
        borderBottom: "2px solid " + black()
      },
      partiallyActive: true
    }, navLink.label), navLink.submenuRows && navLink.submenuRows.length > 0 && /*#__PURE__*/React.createElement(PrimarySubmenu, __assign({
      linkRefs: mergeTwoRefs(linkRefs, secondaryRefs),
      navLink: navLink,
      linkComponent: linkComponent
    }, state
    /* eslint-disable-line react/jsx-props-no-spreading, max-len */
    )));
  }))), /*#__PURE__*/React.createElement(RightSide, null, isLoading || !content ? [1, 2].map(function (i) {
    return /*#__PURE__*/React.createElement(WidgetWrapper, {
      key: i,
      "data-test": 'header-desktop-secondary-link'
    }, /*#__PURE__*/React.createElement(DataPresenter, {
      nodata: true,
      loading: isLoading || false,
      width: 8,
      height: 2
    }));
  }) : content.secondaryNavigationLinks.map(function (secLink, i) {
    var _a;

    return /*#__PURE__*/React.createElement(WidgetWrapper, {
      key: secLink.id,
      "data-test": 'header-desktop-secondary-link'
    }, secLink && ((_a = secLink.submenuItems) === null || _a === void 0 ? void 0 : _a.length) > 0 ? /*#__PURE__*/React.createElement(WidgetItem, {
      ref: function ref(el) {
        if (secondaryRefs === null || secondaryRefs === void 0 ? void 0 : secondaryRefs.current) {
          secondaryRefs.current[i] = {
            current: el
          };
        }
      },
      tabIndex: 0,
      onClick: function onClick() {
        return secWidgetActivate(secLink.id);
      },
      onKeyPress: function onKeyPress(e) {
        if (e.key === 'Enter') {
          secWidgetActivate(secLink.id);
        }
      },
      "data-test": 'header-desktop-secondary-submenu-trigger',
      "data-ga-trigger": true
    }, /*#__PURE__*/React.createElement(WidgetIcon, {
      src: secLink.icon.url,
      alt: secLink.icon.alternativeText || '',
      loading: 'lazy'
    }), /*#__PURE__*/React.createElement(WidgetItemLabel, null, secLink.label)) : /*#__PURE__*/React.createElement(WidgetItem, {
      tabIndex: 0,
      onClick: function onClick() {
        return secWidgetNoBubItemsActivate(secLink.handlerId);
      },
      onKeyPress: function onKeyPress(e) {
        if (e.key === 'Enter') {
          secWidgetNoBubItemsActivate(secLink.handlerId);
        }
      }
    }, /*#__PURE__*/React.createElement(WidgetIcon, {
      src: secLink.icon.url,
      alt: secLink.icon.alternativeText || '',
      loading: 'lazy'
    }), /*#__PURE__*/React.createElement(WidgetItemLabel, null, secLink.label)), secLink.submenuItems && secLink.submenuItems.length > 0 && /*#__PURE__*/React.createElement(SecondarySubmenu, __assign({
      linkRefs: mergeTwoRefs(linkRefs, secondaryRefs),
      link: secLink,
      linkId: "sec-" + secLink.id,
      isMobile: false,
      linkComponent: linkComponent
    }, state
    /* eslint-disable-line react/jsx-props-no-spreading, max-len */
    )));
  }), /*#__PURE__*/React.createElement(LanguageSwitcher, {
    linkComponent: linkComponent,
    translationLinks: translationLinks,
    t: t,
    locale: locale
  })));
};

export default HeaderDesktop;